import request from './request'

export interface supplierDto {
  supplier_id: number
  name: string
}
export function getSupplierList (): Promise<{ data: supplierDto[]}> {
    return request.get('/questionnaire/getSupplierList')
}
export interface occupationDto {
  occupation_id: number
  name: string
}
export function getOccupationList (): Promise<{ data: occupationDto[]}> {
    return request.get('/questionnaire/getOccupationList')
}

export interface addQuesReqDto {
  clientName: string,
  companyName: string,
  occupationTips: string,
  workVideo: string[], // 存储上传的视频文件
  supplier: string[],
  occupation: string[],
  involveLoading: string|number,
  involveMachine: string|number,
}

export function send (params: addQuesReqDto): Promise<{ data: occupationDto[]}> {
    return request.post('/questionnaire/send', params)
}
